













import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class FooterSignin extends Vue {
    // @Prop() private title!: string;
}
